<template>
  <div>
    <h2 class="text-left alert" :class="[removed ? 'alert-danger' : 'alert-success']">
      Cow Environment
      <a class="btn btn-sm" @click="$emit('onRemoveSection', stepName)">
        <span class="glyphicon" :class="[removed ? 'glyphicon-plus' : 'glyphicon-remove']"></span>
      </a>
    </h2>

    <template v-if="!removed">
      <subsection
        :title="farm.farm_label"
        :step-name="stepName"
        :subsection="`farm_${farm.id}-cow_environment`"
        v-for="farm in model.FARMS"
        :key="farm.id"
      >
        <dl class="dl-horizontal">
          <dt>Do the cows calve on the milking platform?</dt>
          <dd>{{ model[`farm_${farm.id}-is_calving_cows_on_platform`] || '-' }}</dd>
        </dl>

        <dl class="dl-horizontal">
          <dt>Location of cows for calving?</dt>
          <dd>{{ model[`farm_${farm.id}-location_of_calving_cows`] || '-' }}</dd>
        </dl>
        <report-comment
          :field_name="`farm_${farm.id}-location_of_calving_cows`"
          :model="model.COMMENTS"
          :heading="false"
        >
        </report-comment>

        <dl class="dl-horizontal">
          <dt>Feed pad used during season?</dt>
          <dd>{{ model[`farm_${farm.id}-is_feed_pad_used_season`] || '-' }}</dd>
        </dl>

        <dl class="dl-horizontal">
          <dt>Herd flow to and from shed disrupted by road crossing, waiting for second herd etc.</dt>
          <dd>{{ model[`farm_${farm.id}-is_herd_flow_disrupted`] || '-' }}</dd>
        </dl>
        <report-comment :field_name="`farm_${farm.id}-is_herd_flow_disrupted`" :model="model.COMMENTS" :heading="false">
        </report-comment>

        <dl class="dl-horizontal">
          <dt>Condition of gateways, underpasses and shed entry/exits?</dt>
          <dd>{{ model[`farm_${farm.id}-condition_of_environment`] || '-' }}</dd>
        </dl>
        <report-comment
          :field_name="`farm_${farm.id}-condition_of_environment`"
          :model="model.COMMENTS"
          :heading="false"
        >
        </report-comment>
      </subsection>
    </template>
  </div>
</template>

<script>
import mixin from './mixin'

export default {
  name: 'CowEnvironment',
  mixins: [mixin],
}
</script>
